import React from "react"

function Works(props) {
  const {works} = props

  function handleClick() {
    if (typeof window !== "undefined") {
      if (window.Beacon) {
        window.Beacon("toggle")
      } else {
        alert("Chat helper connection timeout. Please refresh and try again.");
      }
    }
  }

  return (
    <div className="section-sample-works">
      <div className="container">
        <h2 className="text-center">Sample works</h2>
        <div className="works-wrapper">
          { works.map((item,i) => {
            return <a key={i} href={item.link} className="work-holder" target="_blank" rel="noopener noreferrer">
              <div className="link-sample"><img src={ item.image } className="img-fluid" alt="Icon Work"/></div>
            </a>
          }) }
        </div>
        <a className="btn-blue" target="_blank" href="https://www.figma.com/proto/aZXlNd9gO6otCsX2e9ioCl/Sample-Works-2024-2025--FSHQ---Copy-?node-id=1-23832&p=f&t=brCMVOEUQNKmgkNH-1&scaling=contain&content-scaling=fixed&page-id=0%3A1">See more sample works</a>
      </div>
    </div>
  )
}

export default Works
